module.exports = __webpack_public_path__ + "bac6b6a38dbfa61eccd8d8b41d5ab43f.pdf";